import dayjs from 'dayjs';
import { actionTypes, IInitialState, IFilter, INavigationPagination } from '../../../types';

type Action =
  | { type: typeof actionTypes.SET_FILTER; payload: { property: string; value: string } }
  | { type: typeof actionTypes.SET_SORT; payload: { property: string; value: string } }
  | { type: typeof actionTypes.REMOVE_ALL_FILTER }
  | { type: typeof actionTypes.SET_ITEMS_PER_PAGE; payload: number }
  | { type: typeof actionTypes.SET_PATH; payload: string }
  | { type: typeof actionTypes.SET_NO_PAGINATION; payload: boolean }
  | { type: typeof actionTypes.RESET_FILTER }
  | { type: typeof actionTypes.RESET_SORT }
  | { type: typeof actionTypes.SET_NAVIGATION; payload: INavigationPagination }
  | { type: string; payload?: any };

function getDateFilterQueryString(filter: IFilter): string {
  if (!filter.value && !filter.value.startDate && filter.value.endDate) return '';

  const filtersStr = [];
  if (filter.value.startDate) {
    const startDate = dayjs(filter.value.startDate)
      .set('hour', 0)
      .set('minute', 0)
      .set('second', 0);
    filtersStr.push(`${filter.property}[after]=${startDate.format()}`);
  }

  if (filter.value.endDate) {
    const endDate = dayjs(filter.value.endDate).set('hour', 23).set('minute', 59).set('second', 59);
    filtersStr.push(`${filter.property}[before]=${endDate.format()}`);
  }

  return filtersStr.join('&');
}

const getFilter = (data: any[]): string => {
  if (data.length > 0) {
    return `&${data
      .map((filter: IFilter) => {
        // @todo Je vais gerer les dates ici... Voir Racine.
        if (filter.value.startDate || filter.value.endDate) {
          return getDateFilterQueryString(filter);
        }
        return `${filter.property}=${filter.value}`;
      })
      .join('&')}`;
  }
  return '';
};

export function tableReducer(state: IInitialState, action: Action): IInitialState {
  switch (action.type) {
    case actionTypes.SET_FILTER: {
      // eslint-disable-next-line no-case-declarations
      const filterFiltered = state.filters.filter(
        (filter: IFilter) => filter.property !== action.payload.property
      );

      const updatedSearchParamFilters = state.searchParamFilters.filter(filter => {
        if (action.payload.property === 'createdAt') {
          return !filter.property.includes('createdAt');
        }
        if (action.payload.property === 'declarationDate') {
          return !filter.property.includes('declarationDate');
        }
        if (action.payload.property === 'requestStatusDate') {
          return !filter.property.includes('requestStatusDate');
        }
        return filter.property !== action.payload.property;
      });

      if (action.payload.value === '') {
        return {
          ...state,
          filters: filterFiltered,
          searchParamFilters: updatedSearchParamFilters,
          rowChecked: [],
          path: `${state.basePath}&itemsPerPage=${state.itemsPerPage}&${getFilter(
            filterFiltered
          )}${getFilter(state.sorts)}`,
        };
      }
      // eslint-disable-next-line no-case-declarations
      const newFilters = [...filterFiltered, action.payload];
      newFilters.forEach((filter: IFilter) => {
        if (action.payload.property === 'createdAt' && filter.property === 'createdAt') {
          if (filter.value.startDate) {
            updatedSearchParamFilters.push({
              property: 'createdAt[after]',
              value: filter.value.startDate,
            });
          }
          if (filter.value.endDate) {
            updatedSearchParamFilters.push({
              property: 'createdAt[before]',
              value: filter.value.endDate,
            });
          }
        } else if (
          action.payload.property === 'declarationDate' &&
          filter.property === 'declarationDate'
        ) {
          if (filter.value.startDate) {
            updatedSearchParamFilters.push({
              property: 'declarationDate[after]',
              value: filter.value.startDate,
            });
          }
          if (filter.value.endDate) {
            updatedSearchParamFilters.push({
              property: 'declarationDate[before]',
              value: filter.value.endDate,
            });
          }
        } else if (
          action.payload.property === 'requestStatusDate' &&
          filter.property === 'requestStatusDate'
        ) {
          if (filter.value.startDate) {
            updatedSearchParamFilters.push({
              property: 'requestStatusDate[after]',
              value: filter.value.startDate,
            });
          }
          if (filter.value.endDate) {
            updatedSearchParamFilters.push({
              property: 'requestStatusDate[before]',
              value: filter.value.endDate,
            });
          }
        } else if (action.payload.property === filter.property) {
          updatedSearchParamFilters.push({ property: filter.property, value: filter.value });
        }
      });
      return {
        ...state,
        filters: newFilters,
        searchParamFilters: updatedSearchParamFilters,
        rowChecked: [],
        path: `${state.basePath}&itemsPerPage=${state.itemsPerPage}&${getFilter(
          newFilters
        )}${getFilter(state.sorts)}`,
      };
    }
    case actionTypes.SET_SORT:
      // eslint-disable-next-line no-case-declarations
      const sortFiltered = state.sorts.filter(
        (filter: IFilter) => filter.property !== action.payload.property
      );
      if (action.payload.value === '') {
        return {
          ...state,
          sorts: sortFiltered,
          rowChecked: [],
          path: `${state.basePath}&itemsPerPage=${state.itemsPerPage}&${getFilter(
            state.filters
          )}${getFilter(sortFiltered)}`,
        };
      }
      // eslint-disable-next-line no-case-declarations
      const newSorts = [...sortFiltered, action.payload];
      return {
        ...state,
        sorts: newSorts,
        rowChecked: [],
        path: `${state.basePath}&itemsPerPage=${state.itemsPerPage}&${getFilter(
          state.filters
        )}${getFilter(newSorts)}`,
      };
    case actionTypes.REMOVE_ALL_FILTER:
      return {
        ...state,
        filters: [],
        rowChecked: [],
        path: `${state.basePath}&itemsPerPage=${state.itemsPerPage}`,
      };
    case actionTypes.SET_ITEMS_PER_PAGE:
      return {
        ...state,
        path: `${state.basePath}&itemsPerPage=${action.payload}${getFilter(
          state.filters
        )}${getFilter(state.sorts)}`,
        itemsPerPage: Number(action.payload),
        rowChecked: [],
      };
    case actionTypes.SET_PATH:
      return {
        ...state,
        rowChecked: [],
        path: action.payload,
      };
    case actionTypes.SET_NO_PAGINATION:
      return {
        ...state,
        isPagination: action.payload,
      };
    case actionTypes.RESET_FILTER:
      return {
        ...state,
        filters: [],
        searchParamFilters: [],
        rowChecked: [],
        path: `${state.basePath}&itemsPerPage=${state.itemsPerPage}&${getFilter(state.sorts)}`,
      };
    case actionTypes.RESET_SORT:
      return {
        ...state,
        sorts: [],
        rowChecked: [],
        path: `${state.basePath}&itemsPerPage=${state.itemsPerPage}&${getFilter(state.filters)}`,
      };
    case actionTypes.RESET_CHECK_TO:
      return {
        ...state,
        rowChecked: [...action.payload],
      };
    case actionTypes.SET_CHECK:
      return {
        ...state,
        rowChecked: [...state.rowChecked, action.payload],
      };
    case actionTypes.SET_CHECK_ALL:
      return {
        ...state,
        rowChecked: [...new Set([...state.rowChecked, ...action.payload])],
      };
    case actionTypes.UNCHECK_ALL:
      return {
        ...state,
        rowChecked: action.payload
          ? [...new Set([...state.rowChecked.filter((row: any) => !action.payload.includes(row))])]
          : [],
      };
    case actionTypes.UNCHECK:
      return {
        ...state,
        rowChecked: [...state.rowChecked.filter((row: any) => row !== action.payload)],
      };
    case actionTypes.CLEAR_SEARCH_PARAM: {
      const updatedFilters = state.filters.filter(
        (filter: IFilter) =>
          !state.searchParamFilters.some(searchFilter => {
            if (searchFilter.property.includes('createdAt') && filter.property === 'createdAt')
              return true;
            if (
              searchFilter.property.includes('declarationDate') &&
              filter.property === 'declarationDate'
            )
              return true;
            if (
              searchFilter.property.includes('requestStatusDate') &&
              filter.property === 'requestStatusDate'
            )
              return true;
            return searchFilter.property === filter.property;
          })
      );
      return {
        ...state,
        filters: updatedFilters,
        searchParamFilters: [],
        rowChecked: [],
        path: `${state.basePath}&itemsPerPage=${state.itemsPerPage}&${getFilter(
          updatedFilters
        )}${getFilter(state.sorts)}`,
      };
    }
    case actionTypes.RESET_INITIAL_STATE:
      return action.payload;
    default:
      throw new Error();
  }
}
